<ng-container *ngIf="container; else noData">
  <dx-tab-panel
    [animationEnabled]="true"
    [swipeEnabled]="false"
    iconPosition="start"
    stylingMode="primary"
    width="100%">

    <dxi-item [title]="'Container' | translate">
      <div *dxTemplate>
        <div class="inspect-content p-2">

          <div class="context-row">
            <div class="context-label">{{ 'Letzte Änderung' | translate }}</div>
            <div class="context-value">
              {{ container?.lastChanged ? (container.lastChanged | date:'short') : 'n/b' }}
            </div>
            <div class="context-actions"></div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Typ' | translate }}</div>
            <div class="context-value">{{ dataSource?.type || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Aktiver Katalog' | translate }}</div>
            <div class="context-value">{{ activeCatalogName || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Kataloge' | translate }}</div>
            <div class="context-value">{{ container?.catalogIds?.length || 0 }}</div>
          </div>

          <div class="context-row context-top">
            <div class="context-label">{{ 'Verantwortlich' | translate }}</div>
            <div class="context-value">
              <div *ngIf="dataSource?.contactPerson">{{ dataSource.contactPerson }}</div>
              <div *ngIf="dataSource?.supportTel" class="container-meta-secondary">{{ dataSource.supportTel }}</div>
              <a *ngIf="dataSource?.supportMail"
                 [href]="'mailto:' + dataSource.supportMail"
                 class="container-meta-mail">{{ dataSource.supportMail }}</a>
              <span *ngIf="!dataSource?.contactPerson && !dataSource?.supportTel && !dataSource?.supportMail">n/b</span>
            </div>
          </div>

          <div class="container-notes-block">
            <div class="context-label">{{ 'Notizen' | translate }}</div>
            <dx-text-area
              class="container-notes-box"
              [(value)]="container.note"
              (onFocusOut)="saveContainerNote()">
            </dx-text-area>
          </div>

        </div>
      </div>
    </dxi-item>

    <dxi-item [title]="'Lieferant' | translate">
      <div *dxTemplate>
        <div class="inspect-content p-2">

            <div class="supplier-edit-toolbar">
                <dx-button
                    class="supplier-edit-btn"
                    icon="edit"
                    stylingMode="text"
                    (onClick)="openSupplierEdit()">
                </dx-button>
            </div>

            <div class="context-row">
            <div class="context-label">{{ 'Name' | translate }}</div>
            <div class="context-value">{{ dataSource?.name || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Typ' | translate }}</div>
            <div class="context-value">{{ dataSource?.type || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Kreditoren Nr' | translate }}</div>
            <div class="context-value">{{ dataSource?.kreditorNr || 'n/b' }}</div>
          </div>

          <div class="context-row context-wrap">
            <div class="context-label">{{ 'Alternative Namen' | translate }}</div>
            <div *ngIf="dataSource?.alternativeNames?.length; else noAltNames" class="context-value chips">
              <span *ngFor="let n of dataSource!.alternativeNames" class="chip">{{ n }}</span>
            </div>
            <ng-template #noAltNames><div class="context-value">n/b</div></ng-template>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Adresse' | translate }}</div>
            <div class="context-value">{{ dataSource?.address || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Website' | translate }}</div>
            <div class="context-value">{{ dataSource?.website || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Beschreibung' | translate }}</div>
            <div class="context-value">{{ dataSource?.description || 'n/b' }}</div>
          </div>

          <div class="context-row">
            <div class="context-label">{{ 'Weitere Marken' | translate }}</div>
            <div class="context-value">{{ dataSource?.brandName || 'n/b' }}</div>
          </div>

            <div class="context-section-heading">
              <b>  {{ 'Info zum Produktsicherheitsgesetz' | translate }}</b>
            </div>

            <div class="context-row">
                <div class="context-label">{{ 'Ansprechpartner' | translate }}</div>
                <div class="context-value">{{ dataSource?.contactPerson || 'n/b' }}</div>
            </div>

            <div class="context-row">
                <div class="context-label">{{ 'Telefon' | translate }}</div>
                <div class="context-value">{{ dataSource?.supportTel || 'n/b' }}</div>
            </div>
            
            <div class="context-row">
                <div class="context-label">{{ 'Email' | translate }}</div>
                <div class="context-value">{{ dataSource?.supportMail || 'n/b' }}</div>
            </div>

            <div class="context-row">
                <div class="context-label">{{ 'Garantie/Produktsicherheit' | translate }}</div>
                <div class="context-value">{{ dataSource?.warrantyPages || 'n/b' }}</div>
            </div>

            <div class="context-row">
                <div class="context-label">{{ 'Support Website' | translate }}</div>
                <div class="context-value">{{ dataSource?.supportWebsite || 'n/b' }}</div>
            </div>
            
        </div>
      </div>
    </dxi-item>

  </dx-tab-panel>
</ng-container>

<ng-template #noData>
  <div class="p-3 text-muted">
    {{ 'Keine Container-Daten vorhanden.' | translate }}
  </div>
</ng-template>

<np-container-edit
  (onSaved)="onContainerSaved($event)"
  [(visible)]="editVisible"
  [container]="container"
  [containerType]="containerType"
  [editMode]="true">
</np-container-edit>


<np-edit-datasource (saved)="onEditSaved($event)"
                    [(visible)]="dataSourcePopupVisible"
                    [dataSource]="dataSource"
                    [showChangeWarning]="showChangeWarningForEditDialog"
                    [editMode]="DataSourceEditMode"
                    [relatedBrands]="relatedBrands"/>